export default __webpack_public_path__ + "static/media/not-found.06429a3b.svg";